import { useRouter } from 'next/router'
import React, { useEffect } from 'react'
import { useLoader } from 'src/lib/contexts/LoaderContext'
import { postRequest } from 'src/lib/core/api-client'
import { useLocale } from 'src/lib/hooks/useLocal'
import { apiURI } from 'src/lib/utils/constants'
import { errorToast, successToast } from 'src/lib/utils/toasters'

const EmailConfirm = ({}) => {
  const { t } = useLocale()
  const router = useRouter()
  const { token } = router.query

  const { setLoaderProperties } = useLoader()

  useEffect(() => {
    if (!Boolean(token)) {
      router.replace('/auth/login')
    }
  }, [token])

  useEffect(() => {
    if (token && typeof token === 'string') {
      setLoaderProperties({ isLoaderVisible: true, message: t('verifying_email') })
      confirmInvitation()
    }
  }, [])

  const confirmInvitation = async () => {
    const payload = { invitation_token: token }
    try {
      const response = await postRequest('/merchant-invitation/accept', apiURI.AUTH_ENGINE, payload)
      const email = (response?.data as any)?.data?.oid
      setLoaderProperties({ isLoaderVisible: false })
      if (!Boolean(email)) {
        router.replace('/auth/login')
        return
      }
      router.push({ pathname: '/auth/email-verify', query: { email } })
    } catch (error: any) {
      console.error(error)
      setLoaderProperties({ isLoaderVisible: false })

      error?.data?.error?.code === 'GE_001'
        ? successToast(error?.data?.error?.message)
        : errorToast('something_went_wrong')
      router.replace('/auth/login')
    }
  }

  return <></>
}

export default EmailConfirm
